<script setup>


import {defineProps} from 'vue';
import {useRoute} from 'vue-router';
import {computed} from 'vue';
import {useStore} from 'vuex';

import {highlightedMagazines, highlightedProjects} from "../../application/Highlighter.js";
import router from "@/router";
import store from "@/store/store";


const props = defineProps({
  projectId: {
    type: [String, Number],
    default: 0
  },
  magazineId: {
    type: [String, Number],
    default: 0
  },
  pagePosition: {
    type: [String, Number],
    default: 0
  },
  marketId: {
    type: [String, Number],
    default: 0
  }
});

const URI = (path) => {
  let url = '/' + path;
  if (props.projectId) {
    url += '/' + props.projectId;
  }
  if (props.magazineId) url += "/" + props.magazineId;
  if (props.pagePosition) url += "/" + props.pagePosition;
  if (props.marketId) url += "/" + props.marketId;
  return url;
}

const isActive = (path) => {
  return useRoute().path.startsWith(path);
}

//userData from vuex store
const userData = computed(() => {
  return store.state.user.userData;
});

const isPageViewHighlighted = computed(() => {
  return highlightedMagazines[props.magazineId]?.pages?.[props.pagePosition]?.pageView?.highlight
});

const isListViewHighlighted = computed(() => {
  return highlightedMagazines[props.magazineId]?.pages?.[props.pagePosition]?.listView?.highlight
});

const routeTo = (path) => {
  const url = URI(path);
  router.push(url);
}
</script>

<template>
  <div class="flex">

    <!-- hightlight button blue if the url starts with the keyword -->
    <div  class="p-2 cursor-pointer" data-ui="page-view" @click="routeTo('project')"
       :class="{'bg-trader-blue text-white': isActive('/project') && !isPageViewHighlighted, 'bg-trader-gray' : !isActive('/project'), 'bg-trader-red text-trader-dark-red' : isPageViewHighlighted}">
      Seitenansicht
    </div>
    <div class="p-2 cursor-pointer" data-ui="list-view" @click="routeTo('list')"
       :class="{'bg-trader-blue text-white': isActive('/list') && !isListViewHighlighted, 'bg-trader-gray' : !isActive('/list'), 'bg-trader-red text-trader-dark-red' : isListViewHighlighted}">
      Listenansicht
    </div>
    <div  @click="routeTo('sort')" class="p-2 cursor-pointer" data-ui="change-position"
       :class="{'bg-trader-blue text-white': isActive('/sort'), 'bg-trader-gray' : !isActive('/sort')}">
      Position ändern
    </div>
  </div>
</template>